<template>
  <div class="wrapper">
    <v-fade-transition>
      <Tour v-if="tour" @close="closeTour" />
    </v-fade-transition>
    <v-fade-transition>
      <ExeedLimit v-if="exeeded" />
    </v-fade-transition>
    <Header />
    <v-main class="main mt-sm-5">
      <v-container fluid class="px-md-7 pr-md-6">
        <v-layout row wrap fill-height>
          <div v-if="status === 'suspend'" class="suspend-message">Your account is currently in&nbsp;<b> restricted mode</b>, please contact our support.</div>
          <v-slide-y-transition mode="out-in">
            <router-view></router-view>
          </v-slide-y-transition>
        </v-layout>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import Header from "../components/Header";
import ExeedLimit from "../components/ExeedLimit";
import Tour from "../components/Tour";
import { mapGetters } from 'vuex'

export default {
  name: "Home",
  components: {
    Header,
    ExeedLimit,
    Tour,
  },
  data() {
    return {
      exeeded: false,
      tour: false,
    };
  },
  computed: {
    ...mapGetters("user", ["status"]),
  },
  methods: {
    closeTour() {
      this.tour = false;
    },
  },
};
</script>
<style scoped>
.wrapper {
  height: 100vh;
  background-color: #eef4ff !important;
}
.main {
  background-color: #eef4ff !important;
}
.suspend-message {
  display:block !important;
  color: white;
  margin: 20px;
  background-color: #e96868;
  border-radius: 20px;
  display: flex;
  align-items: center;
  padding: 10px 18px;
  width: 100%;
}
</style>
